import { Space } from "antd";
import { ButtonGroupProps } from "antd/es/button";
import Skeleton from "../Skeleton/Skeleton";

export interface PageButtonGroupProps extends ButtonGroupProps {
  loading?: boolean;
}

export default function PageButtonGroup({ loading, children, ...props }: PageButtonGroupProps) {
  return loading ? (
    <Skeleton style={{ height: "32px", width: "200px" }} />
  ) : (
    <Space.Compact {...props}>{children}</Space.Compact>
  );
}
